module.exports = __webpack_public_path__ + "static/sajja-9d117b2f581989b12222be136b93c338.jpg";